import React from 'react';
import {
	makeStyles,
	Button,
	Box,
	withStyles,
	FormControlLabel,
	Checkbox,
	Grid,
	MenuItem,
	Radio,
	TextField as TextField2,
} from '@material-ui/core';
import { Field, Form, Formik } from 'formik';
import { TextField } from 'formik-material-ui';
import { useHistory, useLocation } from 'react-router-dom';
import TitleText from '../components/reusableComponents/TitleText';
import {
	FlightFareQuoteEtravDispatch,
	FlightFareQuoteDispatch,
} from '../reducers/HomeReducer';
import { useDispatch } from 'react-redux';
const title = ['Mr', 'Mrs'];
const useStyles = makeStyles((theme) => ({
	selectField: {
		'& .MuiOutlinedInput-root': {
			'& fieldset': {
				border: '1px solid #959595',
			},
		},
		backgroundColor: 'white',
		marginBottom: 30,
		width: '100%',
		marginTop: 10,
		borderRadius: 5,
		[theme.breakpoints.down('xs')]: {
			marginBottom: 15,
			marginTop: 8,
		},
		'& .MuiOutlinedInput-root': {
			borderRadius: 5,
		},
		'& .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root': {
			borderRadius: 5,
		},
	},
	InputPropsStyle: {
		backgroundColor: 'white',
		borderRadius: 15,
	},
	inputPropsStyle: {
		padding: 14,
	},
	createButton: {
		backgroundColor: 'rgb(239, 51, 57)',
		color: 'white',
		borderRadius: 12,
		width: '100%',
		padding: '11px 8px',
		'&:hover': {
			backgroundColor: 'rgb(239, 51, 57)',
		},
	},
	tabBorder: {
		borderBottom: '2px solid transparent',
		color: '#7B95AB',
		fontWeight: 400,
	},
	tabBorderColor: {
		borderBottom: '2px solid #313131',
		color: '#00325B',
		fontWeight: 700,
	},
	tab: {
		[theme.breakpoints.up('sm')]: {
			'& .MuiTab-root': {
				minWidth: 241,
				fontSize: 22,
			},
		},
	},
	date: {
		'& .MuiOutlinedInput-root': {
			borderRadius: 5,
			width: '100%',
		},
	},
	dob: {
		'& .MuiFormControl-root': {
			width: '100%',
		},
	},
	passport: {
		'& .MuiFormControl-root': {
			width: '100%',
		},
	},
	root: {
		'& .MuiFormHelperText-root': {
			fontSize: 12,
		},
		'& .MuiOutlinedInput-input': {
			fontSize: 14,
			padding: '13px 14px',
		},
		'& MuiInputLabel-root': {
			fontSize: 16,
		},
		'& .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root': {
			fontSize: 14,
		},
	},
	root2: {
		'& .MuiOutlinedInput-input': {
			fontSize: 14,
			padding: '13px 14px',
		},
		'& MuiInputLabel-root': {
			fontSize: 16,
		},
		'& .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root': {
			fontSize: 14,
		},
	},
}));
const FlightSummaryForm = () => {
	const classes = useStyles();
	const history = useHistory();
	const location = useLocation();
	const dispatch = useDispatch();
	const handleFormSubmit = (data) => {
		if (location.state.OneflightData) {
			if (location.state.OneflightData.Airline_Code) {
				let formEtravFare = {
					Search_Key: location.state.IDEtrav,
					AirRepriceRequests: [
						{
							Flight_Key: location.state.OneflightData.Flight_Key,
							Fare_Id: location.state.OneflightData.Fares[0].Fare_Id,
						},
					],
					Customer_Mobile: data.phone,
					GST_Input: false,
					SinglePricing: true,
				};

				// dispatch(FlightFareQuoteEtravDispatch(formEtravFare));
				history.push({
					pathname: '/confirmflight',
					state: {
						formData: data,
						body: location.state.body,
						OneflightData: location.state.OneflightData,
						IDTBO: location.state.IDTBO,
						IDEtrav: location.state.IDEtrav,
					},
				});
			} else if (location.state.OneflightData.AirlineCode) {
				let formData1 = {
					TraceId: location.state.IDTBO,
					ResultIndex: location.state.OneflightData.ResultIndex,
				};
				// dispatch(FlightFareQuoteDispatch(formData1));
				history.push({
					pathname: '/confirmflight',
					state: {
						formData: data,
						body: location.state.body,
						OneflightData: location.state.OneflightData,
						IDTBO: location.state.IDTBO,
						IDEtrav: location.state.IDEtrav,
					},
				});
			}
		}
		// else if (location.state.selectedonward) {
		// 	if (location.state.selectedonward[0].Airline_Code) {
		// 		let formEtravFare = {
		// 			Search_Key: location.state.IDEtrav,
		// 			AirRepriceRequests: [
		// 				{
		// 					Flight_Key: location.state.selectedonward[0].Flight_Key,
		// 					Fare_Id: location.state.selectedonward[0].Fares[0].Fare_Id,
		// 				},
		// 			],
		// 			Customer_Mobile: '7870075616',
		// 			GST_Input: false,
		// 			SinglePricing: true,
		// 		};
		// 		let formEtravRule = {
		// 			Search_Key: location.state.IDEtrav,
		// 			Flight_Key: location.state.selectedonward[0].Flight_Key,
		// 			Fare_Id: location.state.selectedonward[0].Fares[0].Fare_Id,
		// 		};
		// 		dispatch(FlightFareQuoteEtravDispatch(formEtravFare));
		// 		// dispatch(FlightFareRuleEtravDispatch(formEtravRule));
		// 	} else if (location.state.selectedonward[0].AirlineCode) {
		// 		let formData1 = {
		// 			TraceId: location.state.IDTBO,
		// 			ResultIndex: location.state.selectedonward[0].ResultIndex,
		// 		};
		// 		dispatch(FlightFareQuoteDispatch(formData1));
		// 	}
		// } else if (location.state.selectedReturn) {
		// 	if (location.state.selectedReturn[0].Airline_Code) {
		// 		let formEtravFare = {
		// 			Search_Key: location.state.IDEtrav,
		// 			AirRepriceRequests: [
		// 				{
		// 					Flight_Key: location.state.selectedReturn[0].Flight_Key,
		// 					Fare_Id: location.state.selectedReturn[0].Fares[0].Fare_Id,
		// 				},
		// 			],
		// 			Customer_Mobile: '7870075616',
		// 			GST_Input: false,
		// 			SinglePricing: true,
		// 		};
		// 		let formEtravRule = {
		// 			Search_Key: location.state.IDEtrav,
		// 			Flight_Key: location.state.selectedReturn[0].Flight_Key,
		// 			Fare_Id: location.state.selectedReturn[0].Fares[0].Fare_Id,
		// 		};
		// 		dispatch(FlightFareQuoteEtravDispatch(formEtravFare));
		// 		// dispatch(FlightFareRuleEtravDispatch(formEtravRule));
		// 	} else if (location.state.selectedReturn[0].AirlineCode) {
		// 		let formData1 = {
		// 			TraceId: location.state.IDTBO,
		// 			ResultIndex: location.state.selectedReturn[0].ResultIndex,
		// 		};
		// 		dispatch(FlightFareQuoteDispatch(formData1));
		// 	}
		// }
		console.log(data);
	};
	// console.log(location.state);
	return (
		<>
			<Formik
				initialValues={{
					email: '',
					phone: '',
					titleA1: '',
					first_nameA1: '',
					last_nameA1: '',
					titleA2: '',
					first_nameA2: '',
					last_nameA2: '',
					titleA3: '',
					first_nameA3: '',
					last_nameA3: '',
					titleA4: '',
					first_nameA4: '',
					last_nameA4: '',
					titleA5: '',
					first_nameA5: '',
					last_nameA5: '',
					titleA6: '',
					first_nameA6: '',
					last_nameA6: '',
				}}
				validate={(values) => {
					const errors = {};
					let isError = false;
					if (!values.email) {
						errors.email = 'Required';
						isError = true;
					} else if (
						!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
					) {
						errors.email = 'Invalid email address';
						isError = true;
					}
					if (!values.phone) {
						errors.phone = 'Required';
						isError = true;
					}
					if (!values.titleA1) {
						errors.titleA1 = 'Required';
						isError = true;
					}
					if (!values.first_nameA1) {
						errors.first_nameA1 = 'Required';
						isError = true;
					}
					if (!values.last_nameA1) {
						errors.last_nameA1 = 'Required';
					}
					if (location.state.body.AdultCount === 2) {
						if (!values.titleA2) {
							errors.titleA2 = 'Required';
							isError = true;
						}
						if (!values.first_nameA2) {
							errors.first_nameA2 = 'Required';
							isError = true;
						}
						if (!values.last_nameA2) {
							errors.last_nameA2 = 'Required';
						}
					}
					if (location.state.body.AdultCount === 3) {
						if (!values.titleA2) {
							errors.titleA2 = 'Required';
							isError = true;
						}
						if (!values.first_nameA2) {
							errors.first_nameA2 = 'Required';
							isError = true;
						}
						if (!values.last_nameA2) {
							errors.last_nameA2 = 'Required';
						}
						if (!values.titleA3) {
							errors.titleA3 = 'Required';
							isError = true;
						}
						if (!values.first_nameA3) {
							errors.first_nameA3 = 'Required';
							isError = true;
						}
						if (!values.last_nameA3) {
							errors.last_nameA3 = 'Required';
						}
					}
					if (location.state.body.AdultCount === 4) {
						if (!values.titleA2) {
							errors.titleA2 = 'Required';
							isError = true;
						}
						if (!values.first_nameA2) {
							errors.first_nameA2 = 'Required';
							isError = true;
						}
						if (!values.last_nameA2) {
							errors.last_nameA2 = 'Required';
						}
						if (!values.titleA3) {
							errors.titleA3 = 'Required';
							isError = true;
						}
						if (!values.first_nameA3) {
							errors.first_nameA3 = 'Required';
							isError = true;
						}
						if (!values.last_nameA3) {
							errors.last_nameA3 = 'Required';
						}
						if (!values.titleA4) {
							errors.titleA4 = 'Required';
							isError = true;
						}
						if (!values.first_nameA4) {
							errors.first_nameA4 = 'Required';
							isError = true;
						}
						if (!values.last_nameA4) {
							errors.last_nameA4 = 'Required';
						}
					}
					if (location.state.body.AdultCount === 5) {
						if (!values.titleA2) {
							errors.titleA2 = 'Required';
							isError = true;
						}
						if (!values.first_nameA2) {
							errors.first_nameA2 = 'Required';
							isError = true;
						}
						if (!values.last_nameA2) {
							errors.last_nameA2 = 'Required';
						}
						if (!values.titleA3) {
							errors.titleA3 = 'Required';
							isError = true;
						}
						if (!values.first_nameA3) {
							errors.first_nameA3 = 'Required';
							isError = true;
						}
						if (!values.last_nameA3) {
							errors.last_nameA3 = 'Required';
						}
						if (!values.titleA4) {
							errors.titleA4 = 'Required';
							isError = true;
						}
						if (!values.first_nameA4) {
							errors.first_nameA4 = 'Required';
							isError = true;
						}
						if (!values.last_nameA4) {
							errors.last_nameA4 = 'Required';
						}
						if (!values.titleA5) {
							errors.titleA5 = 'Required';
							isError = true;
						}
						if (!values.first_nameA5) {
							errors.first_nameA5 = 'Required';
							isError = true;
						}
						if (!values.last_nameA5) {
							errors.last_nameA5 = 'Required';
						}
					}
					if (location.state.body.AdultCount === 6) {
						if (!values.titleA2) {
							errors.titleA2 = 'Required';
							isError = true;
						}
						if (!values.first_nameA2) {
							errors.first_nameA2 = 'Required';
							isError = true;
						}
						if (!values.last_nameA2) {
							errors.last_nameA2 = 'Required';
						}
						if (!values.titleA3) {
							errors.titleA3 = 'Required';
							isError = true;
						}
						if (!values.first_nameA3) {
							errors.first_nameA3 = 'Required';
							isError = true;
						}
						if (!values.last_nameA3) {
							errors.last_nameA3 = 'Required';
						}
						if (!values.titleA4) {
							errors.titleA4 = 'Required';
							isError = true;
						}
						if (!values.first_nameA4) {
							errors.first_nameA4 = 'Required';
							isError = true;
						}
						if (!values.last_nameA4) {
							errors.last_nameA4 = 'Required';
						}
						if (!values.titleA5) {
							errors.titleA5 = 'Required';
							isError = true;
						}
						if (!values.first_nameA5) {
							errors.first_nameA5 = 'Required';
							isError = true;
						}
						if (!values.last_nameA5) {
							errors.last_nameA5 = 'Required';
						}
						if (!values.titleA6) {
							errors.titleA6 = 'Required';
							isError = true;
						}
						if (!values.first_nameA6) {
							errors.first_nameA6 = 'Required';
							isError = true;
						}
						if (!values.last_nameA6) {
							errors.last_nameA6 = 'Required';
						}
					}
					return errors;
				}}
				onSubmit={handleFormSubmit}>
				{({ submitForm, isSubmitting, values, errors }) => (
					<>
						<Form>
							{/* Email and PhoneNumber Section */}
							<Box
								className={classes.root}
								style={{
									background: 'white',
									padding: '10px 15px',
									border: '1px solid #e6e6e6',
									marginTop: '10px',
									boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
									borderRadius: '5px',
								}}>
								<Grid
									container
									spacing={2}
									alignItems='center'
									style={{ marginTop: 20, alignItems: 'baseline' }}>
									<Grid item xs={12} lg={6}>
										<Field
											component={TextField}
											name='email'
											type='email'
											variant='outlined'
											error={errors.email}
											label='Email ID'
											className={classes.selectField}
											InputProps={{
												className: classes.InputPropsStyle,
											}}
											inputProps={{
												style: { padding: 12 },
											}}
										/>
									</Grid>
									<Grid item xs={12} lg={6}>
										<Field
											component={TextField}
											name='phone'
											type='number'
											variant='outlined'
											error={errors.phone}
											label='Mobile No.'
											className={classes.selectField}
											InputProps={{
												className: classes.InputPropsStyle,
											}}
											inputProps={{
												style: { padding: 12 },
											}}
										/>
									</Grid>
								</Grid>
							</Box>
							{/* for adult 1 */}
							{location.state.body.AdultCount === 1 && (
								<Box
									className={classes.root}
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
									}}>
									<Box display='flex'>
										<TitleText three textStyle={{ marginTop: 10 }}>
											1
										</TitleText>
										<TitleText
											three
											textStyle={{ marginLeft: 5, marginTop: 10 }}>
											Adult
										</TitleText>
									</Box>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA1'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA1}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA1'
												type='text'
												error={errors.first_nameA1}
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA1'
												type='text'
												error={errors.last_nameA1}
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
								</Box>
							)}

							{/* for adult 2 */}
							{location.state.body.AdultCount === 2 && (
								<Box
									className={classes.root}
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
									}}>
									<Box display='flex'>
										<TitleText three textStyle={{ marginTop: 10 }}>
											2
										</TitleText>
										<TitleText
											three
											textStyle={{ marginLeft: 5, marginTop: 10 }}>
											Adult
										</TitleText>
									</Box>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA1'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA1}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA1'
												type='text'
												variant='outlined'
												error={errors.first_nameA1}
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA1'
												type='text'
												error={errors.last_nameA1}
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA2'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA2}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA2'
												type='text'
												variant='outlined'
												error={errors.first_nameA2}
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA2'
												type='text'
												variant='outlined'
												error={errors.last_nameA2}
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
								</Box>
							)}
							{/* for adult 3 */}
							{location.state.body.AdultCount === 3 && (
								<Box
									className={classes.root}
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
									}}>
									<Box display='flex'>
										<TitleText three textStyle={{ marginTop: 10 }}>
											3
										</TitleText>
										<TitleText
											three
											textStyle={{ marginLeft: 5, marginTop: 10 }}>
											Adult
										</TitleText>
									</Box>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA1'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA1}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA1'
												type='text'
												error={errors.first_nameA1}
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA1'
												type='text'
												variant='outlined'
												error={errors.last_nameA1}
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA2'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA2}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA2'
												type='text'
												variant='outlined'
												error={errors.first_nameA2}
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA2'
												type='text'
												error={errors.last_nameA2}
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA3'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA3}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA3'
												type='text'
												error={errors.first_nameA3}
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA3'
												error={errors.last_nameA3}
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
								</Box>
							)}
							{/* for adult 4 */}
							{location.state.body.AdultCount === 4 && (
								<Box
									className={classes.root}
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
									}}>
									<Box display='flex'>
										<TitleText three textStyle={{ marginTop: 10 }}>
											4
										</TitleText>
										<TitleText
											three
											textStyle={{ marginLeft: 5, marginTop: 10 }}>
											Adult
										</TitleText>
									</Box>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA1'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA1}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA1'
												type='text'
												variant='outlined'
												error={errors.first_nameA1}
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA1'
												type='text'
												variant='outlined'
												error={errors.last_nameA1}
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA2'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA2}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA2'
												type='text'
												variant='outlined'
												label='Enter First Name'
												error={errors.first_nameA2}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA2'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												error={errors.last_nameA2}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA3'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA3}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA3'
												type='text'
												variant='outlined'
												error={errors.first_nameA3}
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA3'
												type='text'
												variant='outlined'
												error={errors.last_nameA3}
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA4'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA4}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA4'
												type='text'
												variant='outlined'
												error={errors.first_nameA4}
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA4'
												type='text'
												variant='outlined'
												error={errors.last_nameA4}
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
								</Box>
							)}
							{/* for adult 5 */}
							{location.state.body.AdultCount === 5 && (
								<Box
									className={classes.root}
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
									}}>
									<Box display='flex'>
										<TitleText three textStyle={{ marginTop: 10 }}>
											5
										</TitleText>
										<TitleText
											three
											textStyle={{ marginLeft: 5, marginTop: 10 }}>
											Adult
										</TitleText>
									</Box>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA1'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA1}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA1'
												type='text'
												variant='outlined'
												error={errors.first_nameA1}
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA1'
												type='text'
												variant='outlined'
												error={errors.last_nameA1}
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA2'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA2}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA2'
												type='text'
												error={errors.first_nameA2}
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA2'
												type='text'
												variant='outlined'
												error={errors.last_nameA2}
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA3'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA3}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA3'
												type='text'
												error={errors.first_nameA3}
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA3'
												type='text'
												error={errors.last_nameA3}
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA4'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA4}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA4'
												type='text'
												variant='outlined'
												error={errors.first_nameA4}
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA4'
												type='text'
												error={errors.last_nameA4}
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA5'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA5}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA5'
												type='text'
												variant='outlined'
												error={errors.first_nameA5}
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA5'
												type='text'
												error={errors.last_nameA5}
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
								</Box>
							)}
							{/* for adult 6 */}
							{location.state.body.AdultCount === 6 && (
								<Box
									className={classes.root}
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
									}}>
									<Box display='flex'>
										<TitleText three textStyle={{ marginTop: 10 }}>
											6
										</TitleText>
										<TitleText
											three
											textStyle={{ marginLeft: 5, marginTop: 10 }}>
											Adult
										</TitleText>
									</Box>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA1'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA1}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA1'
												type='text'
												error={errors.first_nameA1}
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA1'
												type='text'
												error={errors.last_nameA1}
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA2'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA2}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA2'
												type='text'
												variant='outlined'
												error={errors.first_nameA2}
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA2'
												type='text'
												variant='outlined'
												error={errors.last_nameA2}
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA3'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA3}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA3'
												type='text'
												variant='outlined'
												label='Enter First Name'
												error={errors.first_nameA3}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA3'
												type='text'
												variant='outlined'
												error={errors.last_nameA3}
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA4'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA4}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA4'
												type='text'
												error={errors.first_nameA4}
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA4'
												type='text'
												error={errors.last_nameA4}
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA5'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA5}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA5'
												type='text'
												error={errors.first_nameA5}
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA5'
												type='text'
												error={errors.last_nameA5}
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA6'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA6}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA6'
												type='text'
												variant='outlined'
												error={errors.first_nameA6}
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA6'
												type='text'
												variant='outlined'
												error={errors.last_nameA6}
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
								</Box>
							)}
							{/* for adult 7 */}
							{location.state.body.AdultCount === 7 && (
								<Box
									className={classes.root}
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
									}}>
									<Box display='flex'>
										<TitleText three textStyle={{ marginTop: 10 }}>
											7
										</TitleText>
										<TitleText
											three
											textStyle={{ marginLeft: 5, marginTop: 10 }}>
											Adult
										</TitleText>
									</Box>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA1'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA1}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA1'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA1'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA2'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA2}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA2'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA2'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA3'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA3}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA3'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA3'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA4'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA4}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA4'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA4'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA5'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA5}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA5'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA5'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA6'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA6}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA6'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA6'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA7'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA6}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA7'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA7'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
								</Box>
							)}
							{/* for adult 8 */}
							{location.state.body.AdultCount === 8 && (
								<Box
									className={classes.root}
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
									}}>
									<Box display='flex'>
										<TitleText three textStyle={{ marginTop: 10 }}>
											8
										</TitleText>
										<TitleText
											three
											textStyle={{ marginLeft: 5, marginTop: 10 }}>
											Adult
										</TitleText>
									</Box>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA1'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA1}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA1'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA1'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA2'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA2}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA2'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA2'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA3'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA3}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA3'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA3'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA4'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA4}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA4'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA4'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA5'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA5}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA5'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA5'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA6'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA6}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA6'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA6'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA7'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA7}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA7'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA7'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA8'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA8}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA8'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA8'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
								</Box>
							)}
							{/* for adult 9 */}
							{location.state.body.AdultCount === 9 && (
								<Box
									className={classes.root}
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
									}}>
									<Box display='flex'>
										<TitleText three textStyle={{ marginTop: 10 }}>
											9
										</TitleText>
										<TitleText
											three
											textStyle={{ marginLeft: 5, marginTop: 10 }}>
											Adult
										</TitleText>
									</Box>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA1'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA1}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA1'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA1'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA2'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA2}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA2'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA2'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA3'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA3}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA3'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA3'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA4'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA4}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA4'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA4'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA5'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA5}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA5'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA5'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA6'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA6}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA6'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA6'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA7'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA7}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA7'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA7'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA8'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA8}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA8'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA8'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA9'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA9}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA9'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA9'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
								</Box>
							)}
							{/* for ChildCount 1 */}
							{location.state.body.ChildCount === 1 && (
								<Box
									className={classes.root}
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
									}}>
									<Box display='flex'>
										<TitleText three textStyle={{ marginTop: 10 }}>
											1
										</TitleText>
										<TitleText
											three
											textStyle={{ marginLeft: 5, marginTop: 10 }}>
											Child
										</TitleText>
									</Box>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC1'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleC1}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC1'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC1'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
								</Box>
							)}
							{/* for Child 2 */}
							{location.state.body.ChildCount === 2 && (
								<Box
									className={classes.root}
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
									}}>
									<Box display='flex'>
										<TitleText three textStyle={{ marginTop: 10 }}>
											2
										</TitleText>
										<TitleText
											three
											textStyle={{ marginLeft: 5, marginTop: 10 }}>
											Child
										</TitleText>
									</Box>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC1'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleC1}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC1'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC1'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC2'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleC2}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC2'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC2'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
								</Box>
							)}
							{/* for Child 3 */}
							{location.state.body.ChildCount === 3 && (
								<Box
									className={classes.root}
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
									}}>
									<Box display='flex'>
										<TitleText three textStyle={{ marginTop: 10 }}>
											3
										</TitleText>
										<TitleText
											three
											textStyle={{ marginLeft: 5, marginTop: 10 }}>
											Child
										</TitleText>
									</Box>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC1'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleC1}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC1'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC1'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC2'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleC2}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC2'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC2'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC3'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleC3}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC3'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC3'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
								</Box>
							)}
							{/* for Child 4 */}
							{location.state.body.ChildCount === 4 && (
								<Box
									className={classes.root}
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
									}}>
									<Box display='flex'>
										<TitleText three textStyle={{ marginTop: 10 }}>
											4
										</TitleText>
										<TitleText
											three
											textStyle={{ marginLeft: 5, marginTop: 10 }}>
											Child
										</TitleText>
									</Box>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC1'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleC1}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC1'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC1'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC2'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleC2}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC2'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC2'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC3'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleC3}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC3'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC3'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC4'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleC4}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC4'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC4'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
								</Box>
							)}
							{/* for Child 5 */}
							{location.state.body.ChildCount === 5 && (
								<Box
									className={classes.root}
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
									}}>
									<Box display='flex'>
										<TitleText three textStyle={{ marginTop: 10 }}>
											5
										</TitleText>
										<TitleText
											three
											textStyle={{ marginLeft: 5, marginTop: 10 }}>
											Child
										</TitleText>
									</Box>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC1'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleC1}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC1'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC1'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC2'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleC2}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC2'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC2'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC3'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleC3}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC3'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC3'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC4'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleC4}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC4'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC4'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC5'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleC5}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC5'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC5'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
								</Box>
							)}
							{/* for Child 6 */}
							{location.state.body.ChildCount === 6 && (
								<Box
									className={classes.root}
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
									}}>
									<Box display='flex'>
										<TitleText three textStyle={{ marginTop: 10 }}>
											6
										</TitleText>
										<TitleText
											three
											textStyle={{ marginLeft: 5, marginTop: 10 }}>
											Child
										</TitleText>
									</Box>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC1'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleC1}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC1'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC1'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC2'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleC2}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC2'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC2'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC3'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleC3}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC3'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC3'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC4'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleC4}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC4'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC4'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC5'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleC5}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC5'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC5'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleC6'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleC6}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameC6'
												type='text'
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameC6'
												type='text'
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
								</Box>
							)}
							{/* submit Button */}
							<Grid container spacing={4} alignItems='center'>
								<Grid item xs={3}></Grid>
								<Grid item xs={4}>
									<Button
										className={classes.createButton}
										onClick={submitForm}
										style={{ marginTop: 10, fontSize: 16 }}
										disabled={isSubmitting}>
										CONTINUE
									</Button>
								</Grid>
								<Grid item xs={4}></Grid>
							</Grid>
						</Form>
					</>
				)}
			</Formik>
		</>
	);
};

export default FlightSummaryForm;
